import { render, staticRenderFns } from "./add-points-plan.vue?vue&type=template&id=04bd1328&scoped=true&"
import script from "./add-points-plan.vue?vue&type=script&lang=js&"
export * from "./add-points-plan.vue?vue&type=script&lang=js&"
import style0 from "./add-points-plan.vue?vue&type=style&index=0&id=04bd1328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd1328",
  null
  
)

export default component.exports